import { createApi, fakeBaseQuery } from "@reduxjs/toolkit/query/react";

export const TAGS = [
  "Courses",
  "Lessons",
  "Cards",
  "UserProgress",
  "Users",
] as const;

export const pedagogueApi = createApi({
  reducerPath: "pedagogueApi",
  baseQuery: fakeBaseQuery(),
  tagTypes: [
    "Courses",
    "Lessons",
    "Subscriptions",
    "Users",
    "UserProgress",
    "Company",
    "Categories",
    "CurrentUser",
    "UserCourses",
    "UserSuggestions",
  ],
  endpoints: () => ({}),
});

export const { injectEndpoints } = pedagogueApi;

// Export all PostgreSQL APIs
export { postgresApi } from "./postgresApi";
export { postgresUserApi } from "./postgresUserApi";
export { postgresCourseApi } from "./postgresCourseApi";
export { postgresPedaApi } from "./postgresPedaApi";
